export default __webpack_public_path__ + "static/fdls-24aeca77b36e23b2da9c636ff6e515df.png";